module.exports = __webpack_public_path__ + "img/logo-europe-1.svg";